import { z } from 'zod';
// Mirrors Prisma's AccountType enum casing (UPPERCASE) — the API serializes raw
// Prisma rows so the wire shape is UPPERCASE. Equality checks in the UI must
// match accordingly. Phase 3e.1 normalized this from the prototype's title-case.
// Phase 12: COST (5xxx, ต้นทุนขาย / COGS) split out from EXPENSE so the IS
// has a proper Cost-of-Sales section. EXPENSE now lives in the 6xxx range
// (S&A, interest, tax). Both share Dr-nature.
export const AccountTypeSchema = z.enum([
    'ASSET',
    'LIABILITY',
    'EQUITY',
    'REVENUE',
    'COST',
    'EXPENSE',
]);
// Per-account dimension policy (Phase 42). Mirrors Prisma's DimensionRequirement
// enum: NONE = dimension not applicable, OPTIONAL = may be supplied,
// REQUIRED = a posting line on this account must carry the dimension.
export const DimensionRequirementSchema = z.enum(['NONE', 'OPTIONAL', 'REQUIRED']);
export const ChartOfAccountSchema = z.object({
    id: z.uuid().optional(),
    code: z.string(),
    nameTh: z.string(),
    nameEn: z.string(),
    type: AccountTypeSchema,
    level: z.number().int().min(0).max(6),
    parentCode: z.string().nullable(),
    isControl: z.boolean(),
    isActive: z.boolean(),
    branchPolicy: DimensionRequirementSchema,
    departmentPolicy: DimensionRequirementSchema,
    // Real-COA grouping columns (spec 43). Display/statement grouping only —
    // majorGroup/midGroup/subGroup drive the /coa tree; fsLine drives the BS/IS
    // line each account rolls into. Nullable until the master seed populates them.
    majorGroup: z.string().nullable().optional(),
    midGroup: z.string().nullable().optional(),
    subGroup: z.string().nullable().optional(),
    fsLine: z.string().nullable().optional(),
});
// 4-digit numeric code per PAE convention (e.g. 1111, 4110). The 1st digit
// implies the account type bucket (1=asset, 2=liability, 3=equity, 4=rev,
// 5=cost / COGS, 6=expense), but we don't enforce that here — the type
// field is the source of truth.
export const CreateChartOfAccountSchema = z.object({
    code: z.string().min(2).max(20),
    nameTh: z.string().min(1).max(200),
    nameEn: z.string().min(1).max(200),
    type: AccountTypeSchema,
    level: z.number().int().min(0).max(6),
    parentCode: z.string().nullable().optional(),
    isControl: z.boolean().optional().default(false),
    isActive: z.boolean().optional().default(true),
    branchPolicy: DimensionRequirementSchema.optional().default('OPTIONAL'),
    departmentPolicy: DimensionRequirementSchema.optional().default('OPTIONAL'),
    majorGroup: z.string().nullable().optional(),
    midGroup: z.string().nullable().optional(),
    subGroup: z.string().nullable().optional(),
    fsLine: z.string().nullable().optional(),
});
export const UpdateChartOfAccountSchema = z.object({
    nameTh: z.string().min(1).max(200).optional(),
    nameEn: z.string().min(1).max(200).optional(),
    type: AccountTypeSchema.optional(),
    level: z.number().int().min(0).max(6).optional(),
    parentCode: z.string().nullable().optional(),
    isControl: z.boolean().optional(),
    isActive: z.boolean().optional(),
    branchPolicy: DimensionRequirementSchema.optional(),
    departmentPolicy: DimensionRequirementSchema.optional(),
    majorGroup: z.string().nullable().optional(),
    midGroup: z.string().nullable().optional(),
    subGroup: z.string().nullable().optional(),
    fsLine: z.string().nullable().optional(),
});
//# sourceMappingURL=coa.js.map